"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUBLISH_TEMP_FILE_SUCCESS = exports.PUBLISH_TEMP_FILE_REQUEST = exports.PUBLISH_TEMP_FILE_FAIL = void 0;
// USE THIS FILE TO CREATE AND EXPORT YOUR MODULE VARIABLES
var PUBLISH_TEMP_FILE_REQUEST = exports.PUBLISH_TEMP_FILE_REQUEST = '@Temp/PUBLISH_TEMP_FILE_REQUEST';
var PUBLISH_TEMP_FILE_SUCCESS = exports.PUBLISH_TEMP_FILE_SUCCESS = '@Temp/PUBLISH_TEMP_FILE_SUCCESS';
var PUBLISH_TEMP_FILE_FAIL = exports.PUBLISH_TEMP_FILE_FAIL = '@Temp/PUBLISH_TEMP_FILE_FAIL';